var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurveIconPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.846 17.23L12.5 14l2 2 4.5-5",
    stroke: "#604DBC",
    strokeWidth: 0.923,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H8.923A.923.923 0 018 19.077V9M16.508 10.846h2.769v2.77",
    stroke: "#604DBC",
    strokeWidth: 0.923,
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuODQ2MTkgMTcuMjMwOEwxMi41IDE0TDE0LjUgMTZMMTkgMTEiIHN0cm9rZT0iIzYwNERCQyIgc3Ryb2tlLXdpZHRoPSIwLjkyMzA3NyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAgMjBMOC45MjMwOCAyMEM4LjQxMzI3IDIwIDggMTkuNTg2NyA4IDE5LjA3NjlMOCA5IiBzdHJva2U9IiM2MDREQkMiIHN0cm9rZS13aWR0aD0iMC45MjMwNzciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjUwNzggMTAuODQ2MkgxOS4yNzdWMTMuNjE1NCIgc3Ryb2tlPSIjNjA0REJDIiBzdHJva2Utd2lkdGg9IjAuOTIzMDc3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgCurveIconPurple as ReactComponent };